import React from 'react';
import JobSearchContainer from './JobSearchContainer';
import About from './about';
import Services from './Services';
import Projects from './Projects';
import Career from './Career';
import LetsTalk from './LetsTalk';
import Carousel from './Carousel';

const HomePage = () => (
    <>
     <JobSearchContainer />
        <Carousel /> {/* Ensure Carousel is correctly imported */}
       
        <About />
        <Services />
        {/* <Projects /> */}
        <Career />
        {/* <LetsTalk /> */}
    </>
);

export default HomePage;
